const pages = {
  auth: {
    root: 'auth',
    login: {
      name: 'login',
      path: '/auth/login',
    },
    register: {
      name: 'register',
      path: '/auth/register',
    },
    forgotPassword: {
      name: 'forgot-password',
      path: '/auth/forgot-password',
    },
    acceptInvite: {
      name: 'accept-invite',
      path: '/auth/accept-invite',
    },
  },
  home: {
    name: 'home',
    path: '/home',
  },
  overview: {
    name: 'overview',
    path: '/overview',
  },
  settings: {
    name: 'settings',
    path: '/settings',
    management: {
      name: 'management',
      path: '/settings/management',
    },
  },
  profile: {
    name: 'profile',
    path: '/profile',
  },
  apiPlayground: {
    name: 'api-playground',
    path: '/api-playground',
  },
  disclosures: {
    root: 'disclosure',
    name: 'disclosure',
    dueDiligence: {
      name: 'due-diligence',
      path: '/disclosure/id/:id/due-diligence',
    },
  },
  cases: { root: 'case', name: 'case' },
  form: {
    name: 'form',
    path: '/form',
  },
  approve: {
    name: 'approve',
    path: '/approve',
  },
  attachment: {
    // Param route: the opaque accessId is the public download token.
    name: 'attachment/:accessId',
    path: '/attachment',
  },
  status: {
    root: 'status',
    unverified: {
      name: 'unverified',
      path: '/status/unverified',
    },
    statusComingSoon: {
      name: 'coming-soon',
      path: '/status/coming-soon',
    },
    statusMaintenance: {
      name: 'maintenance',
      path: '/status/maintenance',
    },
    status404: {
      name: '404',
      path: '/status/404',
    },
    status500: {
      name: '500',
      path: '/status/500',
    },
    statusSuccess: {
      name: 'success',
      path: '/status/success',
    },
    statusFailure: {
      name: 'failure',
      path: '/status/failure',
    },
    statusCancel: {
      name: 'cancel',
      path: '/status/cancel',
    },
  },
};

export default pages;
